import { Route } from "react-router-dom";

import { routes } from "./routes";

export const LearningPathRoutes = () => {
  return (
    <>
      {routes.map(({ path, Component, exact = false }) => (
        <Route path={path} key={path} exact={exact}>
          <Component />
        </Route>
      ))}
    </>
  );
};
